import React from 'react'
import { AuthenticationImageCard } from '../../../molecules/Application/Biometry/AuthenticationImageCard'
import { DocumentsBack, ImageLabelsText } from '../../../redux/reducers/biometry/biometry.constants'
import { useTypedSelector } from '../../../redux/reducers/selectors'
import { Loading } from '../../../ui'
import { AuthorizationHelper } from './helpers/verify-operator.helper'
import { BiometryAnchor, ImageContainer, Legend, Subtitle } from './style'
import { TakePhoto } from './TakePhoto'

interface Props {
  handleOpenDocumentCamera: () => void
  handleOpenUploadDocumentModal: () => void
}

export const FrontDocumentView = ({ handleOpenDocumentCamera, handleOpenUploadDocumentModal }: Props) => {
  const { isLoadingDocument, documentImages } = useTypedSelector(state => ({
    isLoadingDocument: state.biometry.isLoadingDocument,
    documentImages: state.biometry.documentImages,
  }))

  const isOperatorAllowedToUploadImage = AuthorizationHelper.isOperatorAllowedToUploadImage()

  if (isLoadingDocument) {
    return (
      <React.Fragment>
        <Subtitle>Foto do Documento</Subtitle>
        <ImageContainer>
          <Loading />
        </ImageContainer>
      </React.Fragment>
    )
  }

  if (!documentImages) {
    return (
      <React.Fragment>
        <Subtitle>Foto do Documento</Subtitle>
        <Legend>Remova a plastificação do documento para tirar a foto.</Legend>
        <ImageContainer>
          <TakePhoto onClick={handleOpenDocumentCamera} />
          {isOperatorAllowedToUploadImage ? (
            <BiometryAnchor style={{ marginTop: '1vh' }} onClick={handleOpenUploadDocumentModal}>
              Fazer upload da foto
            </BiometryAnchor>
          ) : (
            undefined
          )}
        </ImageContainer>
      </React.Fragment>
    )
  }

  let document
  if (DocumentsBack.find(label => label === documentImages[0].documentType)) {
    document = documentImages.length === 2 ? documentImages[1] : undefined
  } else {
    document = documentImages[0]
  }

  if (!document) {
    return (
      <React.Fragment>
        <Subtitle>Foto do Documento</Subtitle>
        <Legend>Remova a plastificação do documento para tirar a foto.</Legend>
        <ImageContainer>
          <TakePhoto onClick={handleOpenDocumentCamera} />
          {isOperatorAllowedToUploadImage ? (
            <BiometryAnchor style={{ marginTop: '1vh' }} onClick={handleOpenUploadDocumentModal}>
              Fazer upload da foto
            </BiometryAnchor>
          ) : (
            undefined
          )}
        </ImageContainer>
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <Subtitle>Foto do Documento</Subtitle>
      <Legend>Remova a plastificação do documento para tirar a foto.</Legend> <br />
      <Legend>
        Foto de <strong>{ImageLabelsText[document.documentType]}</strong>
      </Legend>
      <ImageContainer>
        <AuthenticationImageCard
          onOpenCamera={handleOpenDocumentCamera}
          imageBase64={document.documentImageBase64}
          isDocument
          ableToUploadPhoto={isOperatorAllowedToUploadImage}
          onUpload={handleOpenUploadDocumentModal}
        />
      </ImageContainer>
    </React.Fragment>
  )
}
